var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_637_700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 0H4.66666C6.13941 0 7.33331 1.19391 7.33331 2.66666V4.66666C7.33331 6.13941 6.13941 7.33331 4.66666 7.33331H2.66666C1.19391 7.33334 0 6.13944 0 4.66666V2.66666C0 1.19391 1.19391 0 2.66666 0Z",
    fill: "#3B60E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0H13.3333C14.8061 0 16 1.19391 16 2.66666V4.66666C16 6.13941 14.8061 7.33331 13.3333 7.33331H11.3333C9.86059 7.33331 8.66669 6.13941 8.66669 4.66666V2.66666C8.66666 1.19391 9.86056 0 11.3333 0Z",
    fill: "#3B60E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 8.6665H4.66666C6.13941 8.6665 7.33331 9.86041 7.33331 11.3332V13.3332C7.33331 14.8059 6.13941 15.9998 4.66666 15.9998H2.66666C1.19391 15.9998 0 14.8059 0 13.3332V11.3332C0 9.86041 1.19391 8.6665 2.66666 8.6665Z",
    fill: "#3B60E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.6665H13.3333C14.8061 8.6665 16 9.86041 16 11.3332V13.3332C16 14.8059 14.8061 15.9998 13.3333 15.9998H11.3333C9.86059 15.9998 8.66669 14.8059 8.66669 13.3332V11.3332C8.66666 9.86041 9.86056 8.6665 11.3333 8.6665Z",
    fill: "#3B60E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_637_700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboardActive.9f28b6fe5c2297dfdc18f2064dc50804.svg";
export { ForwardRef as ReactComponent };